const Marquee = ({ items, className = "", dark = false }) => {
  const row = (
    <div className="flex items-center shrink-0">
      {items.map((it, i) => (
        <span key={i} className="flex items-center">
          <span className={`font-display font-extrabold uppercase tracking-wide text-2xl sm:text-4xl px-6 ${dark ? "text-ink" : "text-white/90"}`}>
            {it}
          </span>
          <span className={`inline-block w-2.5 h-2.5 rotate-45 ${dark ? "bg-ink/60" : "bg-gold"}`} />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`relative overflow-hidden py-5 border-y ${dark ? "bg-silver border-ink/10" : "bg-ink border-line"} ${className}`} data-testid="marquee-band">
      <div className="flex w-max animate-marquee">
        {row}
        {row}
      </div>
    </div>
  );
};

export default Marquee;
